import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  > *:last-child {\n    margin: 0;\n  }\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (min-width: ", "px) {\n    display: none;\n  }\n  @media screen and (max-width: ", "px) {\n    display: block;\n    ", ";\n  }\n\n  @media screen and (max-width: ", "px) {\n    right: 6px;\n\n    ", ";\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (max-width: ", "px) {\n    display: flex;\n    justify-content: center;\n    position: relative;\n    display: block;\n    text-align: center;\n    margin: auto;\n    padding-right: 17px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n\n  > h2 {\n    margin: 0;\n    font-size: 14px;\n    line-height: 22px;\n  }\n  @media screen and (max-width: ", "px) {\n    width: 100%;\n    text-align: center;\n    > h2 {\n      font-size: 12px;\n      line-height: 16px;\n    }\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: inline;\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 30px;\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n  @media screen and (max-width: ", "px) {\n    font-size: 12px;\n    line-height: 16px;\n    padding-top: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: inline;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 22px;\n  margin: 0;\n\n  @media screen and (max-width: ", "px) {\n    font-size: 14px;\n    ", ";\n    text-align: center;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (min-width: ", "px) {\n    margin-right: 16px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  justify-content: space-between;\n  margin: 0 auto;\n  max-width: ", "px;\n  box-sizing: content-box;\n\n  @media screen and (min-width: ", "px) {\n    padding: 0 60px;\n  }\n\n  @media screen and (max-width: ", "px) and (min-width: ", "px) {\n    flex-wrap: wrap;\n    padding: 0 30px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n    padding: 0 20px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  top: 70px;\n  height: 104px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  transition: height 0.1s;\n\n  @media screen and (min-width: ", "px) {\n    top: 80px;\n  }\n  @media screen and (min-width: ", "px) {\n    ", "\n\n    ", "\n  }\n\n  @media screen and (max-width: ", "px) {\n    background-color: ", ";\n    top: ", "px;\n    ", "\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: 64px;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import MediaQuery from 'react-responsive';
import { useMediaQuery } from 'react-responsive';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { A4_ActionButton } from '../A4_ActionButton';
import { A4_BackButton } from '../A4_BackButton';
import { SettingsButton } from '../SettingsButton';
import { SavedLabel } from '../SavedLabel';
import styled from '../utils/styling/styled-components';
import { ACTION_STRIP } from '../utils/testing/TestIDs';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
import { theme } from '../theme';
import { handleBackAction } from '../utils/history';
import { A4_InvertedStrip } from './A4_InvertedStrip';
import { useStickyScroll } from './hooks';
var Container = styled.div(_templateObject(), function (props) {
  return props.collapse && "\n    @media screen and (max-width: ".concat(theme.breakpoints.sm, "px) {\n      min-height: 0;\n    }\n  ");
});
var Content = styled.div(_templateObject2(), theme.breakpoints.md + 1, theme.breakpoints.sm + 1, function (props) {
  return props.scrollPercent >= 0.1 && "box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.04); background-color:".concat(props.stripColor, ";");
}, function (props) {
  return props.sticky && "\n      height: ".concat(104 - (104 - props.stickyHeight) * props.scrollPercent, "px;\n      position: fixed;\n      z-index: 20;\n    ");
}, theme.breakpoints.sm, function (props) {
  return props.stripColor;
}, function (props) {
  return props.top || 69;
}, function (props) {
  return props.scrollPercent >= 0.1 && 'box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.04);';
}, function (props) {
  return props.sticky && "\n      z-index: 20;\n      height: 80px;\n      position: fixed;\n    ";
});
var Constrainer = styled.div(_templateObject3(), function (props) {
  return props.maxWidth;
}, theme.breakpoints.md + 1, theme.breakpoints.md, theme.breakpoints.sm + 1, theme.breakpoints.sm, function (props) {
  return props.customStyle ? props.customStyle : 'flex-wrap: wrap';
});
var TitleContainer = styled.div(_templateObject4());
var BackButtonStyled = styled(A4_BackButton)(_templateObject5(), theme.breakpoints.sm + 1);
var Title = styled.h1(_templateObject6(), theme.colors.slate, theme.breakpoints.sm, function (props) {
  return props.customTitleStyle ? props.customTitleStyle : 'padding-left: 0';
});
var Subtitle = styled.h2(_templateObject7(), theme.colors.stone, theme.breakpoints.md, function (props) {
  return props.sticky && "\n      text-align: center;\n      white-space: nowrap;\n    ";
}, theme.breakpoints.sm, function (props) {
  return props.sticky ? '6px' : '8px';
}, function (props) {
  return props.customSubtextStyle && props.customSubtextStyle;
});
var VerticalSubTextContainer = styled.div(_templateObject8(), theme.breakpoints.sm);
var HorizontalSubtextContainer = styled.div(_templateObject9(), theme.breakpoints.sm);
var SettingsButtonStyled = styled(SettingsButton)(_templateObject10(), theme.breakpoints.md + 1, theme.breakpoints.md, function (props) {
  return props.sticky && "\n    background-color: transparent;\n    box-shadow: none;\n    right: 16px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    ";
}, theme.breakpoints.sm, function (props) {
  return props.sticky && "\n      right: 6px;\n    ";
});
var ActionContainer = styled.div(_templateObject11(), theme.breakpoints.sm, function (props) {
  return (props.sticky || props.showInverted) && !props.showMobileActions && "\n      display: none;\n    ";
});
var defaultProps = {
  collapse: false,
  disableResponsiveSticky: false,
  maxWidth: 1200,
  preventDefault: false,
  showBack: true,
  showInverted: false,
  showResponsiveTitle: true,
  hasStickySettings: false,
  sticky: true,
  stripColor: theme.colors.white,
  invertedStripColor: theme.colors.green,
  invertedStripTransitionColor: theme.colors.white
};

var A4_ActionStrip = function A4_ActionStrip(props) {
  var history = useHistory();
  var location = useLocation();
  var match = useRouteMatch();
  props = _objectSpread(_objectSpread({}, defaultProps), props);

  var _useStickyScroll = useStickyScroll({
    scrollDistance: 64
  }),
      scrollPercent = _useStickyScroll.scrollPercent;

  var isDesktop = useMediaQuery({
    query: "(min-width: ".concat(theme.breakpoints.sm + 1, "px)")
  });
  var isTablet = useMediaQuery({
    query: "(max-width: ".concat(theme.breakpoints.lg, "px) and (min-width: ").concat(theme.breakpoints.sm, "px)")
  });
  var stickyHeight = isDesktop ? 72 : 56;

  var onBackPress = function onBackPress() {
    if (!props.preventDefault || !props.onBack) {
      handleBackAction({
        history: history,
        location: location,
        backOverride: props.backOverride,
        match: match
      });
    }

    if (props.onBack) {
      props.onBack();
    }
  };

  var VerticalSubtext = function VerticalSubtext(props) {
    return /*#__PURE__*/React.createElement(VerticalSubTextContainer, null, props.title && /*#__PURE__*/React.createElement(Title, {
      customTitleStyle: props.customTitleStyle,
      sticky: props.sticky
    }, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtitle, {
      sticky: props.sticky,
      customSubtextStyle: props.customSubtextStyle
    }, props.subtext));
  };

  var HorizontalSubtext = function HorizontalSubtext(props) {
    return /*#__PURE__*/React.createElement(HorizontalSubtextContainer, null, props.title && /*#__PURE__*/React.createElement(Title, {
      customTitleStyle: props.customTitleStyle,
      sticky: props.sticky
    }, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtitle, {
      sticky: props.sticky,
      customSubtextStyle: props.customSubtextStyle
    }, ' ', props.subtext));
  };

  return /*#__PURE__*/React.createElement(Container, {
    collapse: props.collapse || props.showInverted,
    "data-testid": ACTION_STRIP,
    className: props.className
  }, props.showInverted ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: theme.breakpoints.sm
  }, /*#__PURE__*/React.createElement(A4_InvertedStrip, {
    invertedStripColor: props.invertedStripColor,
    invertedStripTransitionColor: props.invertedStripTransitionColor,
    stickyHeight: stickyHeight,
    scrollPercent: scrollPercent,
    onBack: onBackPress,
    showBack: props.showBack,
    subtext: props.invertedSubText,
    icon: props.icon,
    title: props.showResponsiveTitle ? props.invertedTitle : null,
    children: props.children,
    verticalSubText: props.verticalSubText,
    verticalScrollHeight: props.verticalScrollHeight || 6,
    invertedScrollIcon: props.invertedScrollIcon,
    invertedChildrenIcons: props.invertedChildrenIcons,
    invertedChildrenIconsScrolled: props.invertedChildrenIconsScrolled
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: theme.breakpoints.sm + 1
  }, /*#__PURE__*/React.createElement(Content, {
    stripColor: props.stripColor,
    top: props.top,
    scrollPercent: scrollPercent,
    sticky: props.sticky,
    stickyHeight: stickyHeight
  }, /*#__PURE__*/React.createElement(Constrainer, {
    maxWidth: props.maxWidth,
    customStyle: props.customStyle
  }, /*#__PURE__*/React.createElement(TitleContainer, {
    sticky: props.sticky
  }, props.showBack && /*#__PURE__*/React.createElement(BackButtonStyled, {
    onClick: onBackPress,
    sticky: props.sticky
  }), props.verticalSubText ? /*#__PURE__*/React.createElement(VerticalSubtext, props) : /*#__PURE__*/React.createElement(HorizontalSubtext, props), props.hasStickySettings && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "Go to settings"), /*#__PURE__*/React.createElement(SettingsButtonStyled, {
    sticky: props.sticky,
    onClick: props.onSettingsPress
  })), props.savedLabel && /*#__PURE__*/React.createElement(SavedLabel, {
    show: props.savedLabel.saved,
    text: props.savedLabel.text
  })), props.heading, /*#__PURE__*/React.createElement(ActionContainer, {
    customStyle: props.customStyle,
    sticky: props.sticky,
    showInverted: props.showInverted
  }, props.actions && props.actions.map(function (action) {
    return /*#__PURE__*/React.createElement(A4_ActionButton, {
      key: action.id,
      icon: action.icon,
      text: isTablet && props.actions.length > 4 ? null : action.text,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      testId: action.testId,
      className: action.className
    });
  }), props.children))))) : /*#__PURE__*/React.createElement(Content, {
    top: props.top,
    stripColor: props.stripColor,
    scrollPercent: scrollPercent,
    sticky: props.sticky,
    stickyHeight: stickyHeight
  }, /*#__PURE__*/React.createElement(Constrainer, {
    maxWidth: props.maxWidth,
    customStyle: props.customStyle
  }, /*#__PURE__*/React.createElement(TitleContainer, {
    sticky: props.sticky
  }, props.showBack && /*#__PURE__*/React.createElement(BackButtonStyled, {
    onClick: onBackPress,
    sticky: props.sticky
  }), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: theme.breakpoints.sm + 1
  }, props.verticalSubText ? /*#__PURE__*/React.createElement(VerticalSubtext, props) : /*#__PURE__*/React.createElement(HorizontalSubtext, props)), props.hasStickySettings && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "Go to settings"), /*#__PURE__*/React.createElement(SettingsButtonStyled, {
    sticky: props.sticky,
    onClick: props.onSettingsPress
  })), props.savedLabel && /*#__PURE__*/React.createElement(SavedLabel, {
    show: props.savedLabel.saved,
    text: props.savedLabel.text
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: theme.breakpoints.sm
  }, props.verticalSubText ? /*#__PURE__*/React.createElement(VerticalSubtext, props) : /*#__PURE__*/React.createElement(HorizontalSubtext, props)), props.heading, /*#__PURE__*/React.createElement(ActionContainer, {
    showMobileActions: props.showMobileActions,
    customStyle: props.customStyle,
    sticky: props.sticky,
    showInverted: props.showInverted
  }, props.actions && props.actions.map(function (action) {
    return /*#__PURE__*/React.createElement(A4_ActionButton, {
      key: action.id,
      icon: action.icon,
      text: isTablet && props.actions.length > 4 ? null : action.text,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      testId: action.testId,
      className: action.className
    });
  }), props.children))));
};

export default A4_ActionStrip;